import { createSlice } from '@reduxjs/toolkit';
import socket from '../../utils/socket';

const initialState = {
  isLoading: false,
  error: false,
  clockingAnomalyReasons: [],
  clockingAnomalyReason: null
};

const slice = createSlice({
  name: 'clockingAnomalies',
  initialState,
  reducers: {
    // LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    // ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
      console.error(state.error);
    },
    getClockingAnomalyReasons(state, action) {
      state.clockingAnomalyReasons = action.payload.clocking_anomaly_reasons;
      state.isLoading = false;
    },
    setClockingAnomalyReason(state, action) {
      state.clockingAnomalyReason = action.payload;
    }
  }
});

// Reducer
export default slice.reducer;
// actions
export const { setClockingAnomalyReason } = slice.actions;

// Actions
// export const {} = slice.actions;

export function getClockingAnomalyReasons() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const result = await socket.get('/clocking_anomaly_reasons');
      dispatch(slice.actions.getClockingAnomalyReasons(result));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
